// extracted by mini-css-extract-plugin
export default {"buttonFooter":"buttonFooter__Rx2Aj","iconButtonFooter":"iconButtonFooter__v4Vew","noImagePlaceholder":"noImagePlaceholder__WczLG"};